import * as React from "react";
import Component from "../../AbstractComponent";
// import { TaskTemplateInterface } from "../../../Entity/Entities/Task/TaskTemplateInterface";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

export default class TaskSummary extends Component {
  constructor(public props) {
    super(props);
  }

  public render() {
    const typeOfExecutor = this.props.task.executorCompany
      ? 'company'
      : this.props.task.executor?.nameForUrl
    const typeOfReporter = this.props.task.reporterCompany
      ? 'company'
      : this.props.task.reporter?.nameForUrl
      const reporterId = this.props.task.reporterCompany
      ? this.props.task.reporter?.companyId || this.props.task.reporter?.companies[0]?.id
        : this.props.task.reporter?.id 
    const executorId = this.props.task.executorCompany
      ? this.props.task.executor?.companyId || this.props.task.executor?.companies[0]?.id
      : this.props.task.executor?.id 

    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div className="payment-summary" style={{ padding: '10px 40px 10px 10px', marginBottom: '10px' }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div className="title">
              {this.trans("page/taskupdate-hint/taskfor", { entity: this.props.selectedEntityForTask?.nameOfEntity }).toUpperCase()}
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>

            <table>
              <tr>
              <td className="align-left first-column">
                <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                  {`${this.trans("registered-by")}: `}
                </div>
              </td>
              <td className="align-left">
                <span className="link-to-entity" onClick={() => this.redirect(`/app/user/update/${this.props.task && this.props.task.createdBy}`)}>
                  {this.props.task && this.props.task.creator && this.props.task.creator.displayName}
                </span>
              </td>
            </tr>
              {this.props.selectedEntityForTask && this.props.selectedEntityForTask.shortDisplayName &&
                <tr>
                  <td className="align-left first-column">
                    <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                      {`${this.trans("page/taskupdate-hint/taskfor", { entity: this.props.selectedEntityForTask.nameOfEntity })}: `}
                    </div>
                  </td>
                  <td className="align-left">
                    <span className="link-to-entity" onClick={() => this.redirect(`/app/${this.props.selectedEntityForTask.nameOfEntity === "Activity" ? this.props.selectedEntityForTask.nameOfEntity.toLowerCase() : this.props.selectedEntityForTask.nameForUrl}/update/${this.props.selectedEntityForTask.id}`)}>
                      {this.props.selectedEntityForTask && this.props.selectedEntityForTask.shortDisplayName}
                    </span>
                  </td>
                </tr>
              }

              {this.props.task && this.props.task.reporter &&
                <tr>
                  <td className="align-left first-column">
                    <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                      {`${this.trans("reported-by")}: `}
                    </div>
                  </td>
                  <td className="align-left">
                    <span className="link-to-entity" onClick={() => this.redirect(`/app/${typeOfReporter}/update/${reporterId}`)}>
                      {this.props.reporterDisplayName}
                    </span>
                  </td>
                </tr>
              }

              {this.props.task && this.props.task.executor &&
                <tr>
                  <td className="align-left first-column">
                    <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                      {`${this.trans("assignee")}: `}
                    </div>
                  </td>
                  <td className="align-left">
                    <span className="link-to-entity" onClick={() => this.redirect(`/app/${typeOfExecutor}/update/${executorId}`)}>
                    {this.props.executorDisplayName}
                    </span>
                  </td>
                </tr>
              }

              <tr>
                {this.props.task && this.props.task.content.name &&
                  <>
                    <td className="align-left first-column">
                      <div style={{ color: "gray", fontSize: "14px", marginRight: "5px" }}>
                        {`${this.trans("label-description")}:`}
                      </div>
                    </td>
                    <td className="align-left">

                      <span style={{whiteSpace: 'pre-line'}}>
                        {this.props.task.content.name}
                      </span>
                    </td>
                  </>
                }
              </tr>
            </table>
          </div>
        </div>
        <div style={{ position: "absolute", right: "20px", top: "35px" }}>
          <FormControlLabel
            control={
              <Switch
                checked={this.props.reacted}
                onChange={this.props.changeStatus}
                color="primary"
              />
            }
            label={this.trans("status-finished")}
          />
        </div>
      </div>

    );
  }
}
